import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import {isMobileOnly} from 'react-device-detect';
import { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import MyEsCurrencyInputComp from '../../components/common/input/MyEsCurrencyInputComp';
import { setEsMyBudgetAction, reqEsBrandCate2Name, setEsMyBrandCate3StepAction, setEsMySelBrandStep3Action } from '../../modules/es/esMyModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import {Toast, toast, ToastLeft} from '../../components/common/noti/Toast';
import Footer from "../../components/common/Footer";
import { getCateListAction } from '../../modules/common/cateModule';
import { forEach} from 'lodash';

const EstimateStepBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        //padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};

    .yellow {
        color: #ffc742;
    }
`;

const EstimateStepHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 0 42px 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        margin-bottom: 60px;
    `};
    position:relative;

    .title-num {
        //width: 100vw;
        height: 50px;
        color: #cccccc;
        font-family: 'Berkshire Swash';
        font-size: 18px;
        line-height: 1.28;
        padding-top: 8px;

        .num-left {
            margin-right: 8px;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 4px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/arrow_my_title.svg) center center/auto no-repeat;
                vertical-align: 6px;
            }
        }
        .num-right {
            margin-left: 8px;
        }
    }

    .close {
        margin-top: 6px;
        margin-right: -3vw;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
    }
    
    .title {
        ${isMobileOnly?`
        font-size: 22px;
        line-height: 1.45;
        `:`
        font-size: 24px;
        line-height: 1.5;
        `};
        font-family: NotoSansKR;
        font-weight: bold;
        color: #111111;
    }

    .sub {
        font-size: 12px;
        font-weight: normal;
        font-family: NotoSansKR;
        line-height: 2.17;
        color: #cccccc;
    }
`;

const EstimateStepContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const EstimateStepBottomBlock = styled.div`
    ${isMobileOnly?`
    position:fixed;
    width: 100vw;
    padding: 20px 10px 30px;
    margin: 0 -4vw; 
    `:`
    position:absolute;
    padding: 20px;
    width: 640px;
    border-top: solid 1px #cccccc;
    `};

    bottom:0;
    z-index: 10;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    //border-top: solid 1px #cccccc;
    
    display: ${props => props.display || 'none'};
    background-color: #ffffff;

    .list {
        ${isMobileOnly?`
        padding: 0 18px 0 16px;
        `:`
        padding: 0 0 0 0;
        `};
        
    }
    .title {
        color: #999999;
        //margin: 0 18px 0 16px;
        width: 96px;
        display: inline-block;
    }
    .desc {
        color: #333333;
    }

    .num {
        font-weight: 600;
    }

    .green {
        //margin: 0 18px 0 16px;
        color: #79b88a;
    }

    .pre {
        border-radius: 4px;
        background-color: #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
    }

    .next {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;
    }
`;

const EstimateStepBlankBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    ${isMobileOnly?`
    height: 200px;
    `:`
    height: 120px;
    `};
`;

const EstimateStepContentsPCBlock = styled.div`
    width: 1176px;
    margin: 0 auto;
    margin-top: 80px;
    .left_con {
        width: 720px;
        height: 707px;
        float: left;
        position: relative;
        padding: 40px 40px 0px 40px;
        border-radius: 10px;
        border: solid 1px #666666;
        margin-left: 40px;
        ::after {
            content: '';
            display: inline-block;
            width: 48px;
            height: 50px;
            background: url(/assets/images/icon/clip.png) center center/auto no-repeat;
            position: absolute;
            background-size: 48px 50px;
            top: -27px;
            right: 33px;
        }
    }

    .right_con {
        width: 355px;
        float: left;
        margin-left: 20px;
        position: relative;
        height: 707px;

        .title {
            font-size: 18px;
            font-weight: 500;
            line-height: 2;
            color: #333333;
            margin-bottom: 15px;
            line-height: 1.2;
        }

        .step {
            font-size: 20px;
            font-weight: 500;
            color: #111111;
            line-height: 1.2;

            .five {
                font-weight: normal;
                color: #999999;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #cccccc;
        }

        .sub_title {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #999999;
            padding-left: 20px;
        }

        .sub_content {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            margin-top: 8px;
            padding: 0 20px;
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
        }
        .next {
            border-radius: 4px;
            background-color: #111111;
            text-align: center;
            color: #ffffff;
            height: 52px;
            width: 100%;
            
        }
        .pre {
            border-radius: 4px;
            //background-color: #ececec;
            text-align: center;
            color: #333333;
            height: 52px;
            width: 100%;
            float: left;
            border: solid 1px #cccccc;
            background-color: #ffffff;
        }
    }
`;

const EstimateStep2 = () => {

    const dispatch = useDispatch();
    const refContainer = useRef(null);
    const history = useHistory();
    const [focused, setFocused] = useState(false);
    const [price, setPrice] = useState(0);
    const priceRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const [cate2Item, setCate2Items] = useState("");

    const { categoryItems, error ,esMyBrandCate1Step, esBrandMyStep1, esMyBudget} = useSelector(
        ({ cateItemsReducer, esMyReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandMyStep1: esMyReducer.esBrandMyStep1,
            esMyBudget:esMyReducer.esMyBudget
        })
    );


    // 최소 실행시 Header 관련 처리 추가  
    useEffect(() => {
        dispatch(setCurMenuAction('esapply'));
        dispatch(setHeaderTransferAction(false));
        //dispatch(reqEsBrandCate2Name());

        if(history.action !== 'POP'){
            let data = [];
            //dispatch(setEsMyBudgetAction(0));
        } 
        //let cate=[]
        //dispatch(setEsMyBrandCate3StepAction(cate));

        //console.log("esBrandMyStep1 = " + esBrandMyStep1)
        if(esBrandMyStep1 === null) {
            //history.replace('/estimate/step1');
            history.goBack();
        }

        //3단계초기화
        //let data = [];
        //dispatch(setEsMySelBrandStep3Action(data));
    }, []);

    useEffect(() => {
        if(esBrandMyStep1 === null) {
            //history.replace('/estimate/step1');
            history.goBack();
        }
    }, [esBrandMyStep1]);

    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {

            if(!isMobileOnly&&esMyBrandCate1Step&&categoryItems&&categoryItems.length>0) {
                let txtCate2 = "";
                forEach(categoryItems, (curobj, index) => {
                    let cate = curobj;
                    //console.log('cate = ' + JSON.stringify(cate))
                    if(cate !== null && cate !== undefined) {
                        let cate1Id = cate.id*100;
                        forEach(cate.cate2, (cate2, index) => {
                            let cateId = cate1Id + cate2.id*1;
                            for(let i =0 ; i < esMyBrandCate1Step.length; i++){
                                if(esMyBrandCate1Step[i] === cateId) {
                                    if(txtCate2.length === 0) {
                                        txtCate2 = cate2.cate_name + "";
                                    } else {
                                        txtCate2 = txtCate2 + ", "+cate2.cate_name;
                                    }
                                }
                            }
                        });
                    }
                    
                });
    
                //console.log("txtCate2 = " + txtCate2)
                setCate2Items(txtCate2);
            }
        }

    }, [categoryItems]);

    const handleChangePrice = (value) => {
        
        
        if (isNaN(value) || value < 0) {
            return;
        }

        //console.log("price = " + value);
        setPrice(value/1);
    }

    // 패키지 금액 포커서 확인
    const handleChangeCurInputFocus = () => {
        // console.log("handleChangeCurInputFocus")
        setFocused(true);
    }

    const handleChangeCurInputBlur = () => {
        // console.log("handleChangeCurInputBlur")
        setFocused(false);
    }

    const handlePre = () => {
        //setOpenModal(true);
        history.goBack();
    }

    const handleNext = () => {
        if(price < 1) {
            let msg = "예산을 입력해주세요 🙂";
            toast('SUCCESS', msg);
            return;
        }
        dispatch(setEsMyBudgetAction(price));
        history.push("/estimate/step3");
    }

    const handleModalBtn1Click = () => {
        dispatch(setEsMyBudgetAction(price));
        setOpenModal(false);
        history.goBack();
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getPopup = () => {
        let msg = "해당 Step에서 입력한 모든 내용이\n초기화 됩니다";
        return (<NormalPopup
            text={""}
            text2={msg}
            text3={""}
            btn1="뒤로가기" btn2="취소"
            onClick1={handleModalBtn1Click}
            onClick2={handleModalBtn2Click} />)

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    const getPrice = () => {
        if(price === 0) {
            return "";
        } else {
            return Number(price.toFixed(1)).toLocaleString() + "원"
        }

    }
    return (isMobileOnly?
        <EstimateStepBlock>
                {/* <Header /> */}
                <EstimateStepHeaderBlock className="clearfix">
                    <div className="clearfix">
                    <div className="title-num f-left"><span className="num-left">2</span><span>4</span></div>{/* <div className="close f-right"></div> */}
                    </div>
                    <div className="title"><p><span className="yellow">생각하신 예산</span>은</p><p>얼마인가요?🧐</p></div>
                    {/* <div className="sub">나만의 가구 견적 알아보기</div> */}

                </EstimateStepHeaderBlock>
                <EstimateStepContentsBlock ref={refContainer}>
                <MyEsCurrencyInputComp
                                    marginLeft='10px'
                                    //width='calc(92vw - 30px)'
                                    height='33px'
                                    //float='left'
                                    //marginRight='-13px'
                                    placeholder='0'
                                    onChange={handleChangePrice}
                                    onFocus={handleChangeCurInputFocus}
                                    onBlur={handleChangeCurInputBlur}
                                    maxLength='14'
                                    inputRef={priceRef}
                                    textAlign='left'
                                    fontWeight='500'
                                    fontSize='24px'
                                    border='none'
                                    focusBorder='none'
                                />
                </EstimateStepContentsBlock>
                <EstimateStepBlankBlock >&nbsp;</EstimateStepBlankBlock>
            <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                <div className="list margin_b-10"><span className="title">상품 가격 범위</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                <div className="list margin_b-20"><div className="green">*상품 1개의 가격 범위를 참고해주세요.</div></div>
                <button className="pre" onClick={handlePre}>이전</button><button className="next" onClick={handleNext}>다음</button>
            </EstimateStepBottomBlock>
            <Toast bottom={"30px"}/>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
        </EstimateStepBlock>
        :
        <EstimateStepBlock>
                <Header />
                <EstimateStepContentsPCBlock className="clearfix">
                    <div className="left_con clearfix">
                        <EstimateStepHeaderBlock className="clearfix">
                            <div className="title"><p><span className="yellow">생각하신 예산</span>은 얼마인가요?🧐</p></div>
                        </EstimateStepHeaderBlock>
                        <EstimateStepContentsBlock ref={refContainer}>
                        <MyEsCurrencyInputComp
                                            marginLeft='10px'
                                            //width='calc(92vw - 30px)'
                                            height='33px'
                                            //float='left'
                                            //marginRight='-13px'
                                            placeholder='0'
                                            onChange={handleChangePrice}
                                            onFocus={handleChangeCurInputFocus}
                                            onBlur={handleChangeCurInputBlur}
                                            maxLength='14'
                                            inputRef={priceRef}
                                            textAlign='left'
                                            fontWeight='500'
                                            fontSize='24px'
                                            border='none'
                                            focusBorder='none'
                                        />
                        </EstimateStepContentsBlock>

                        <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                            <div className="list margin_b-10"><span className="title">상품 가격 범위</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                            <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                            <div className="list margin_b-20"><div className="green">*상품 1개의 가격 범위를 참고해주세요.</div></div>
                        </EstimateStepBottomBlock>
                    </div>
                    <div className="right_con clearfix">
                        <div className="title">나만의 상품 견적 알아보기</div>
                        <div className="step margin_b-40"><span>Step 2 </span><span className="five">/ 4</span></div>
                        <div className="line margin_b-20" />
                        <div className="sub_title">1. 카테고리</div>
                        <div className="sub_content margin_b-20">{cate2Item}</div>
                        <div className="sub_title">2. 예산</div>
                        <div className="sub_content">{getPrice()}</div>
                        <div className="line margin_t-20" />
                        <div className="bottom">
                            <button className="next margin_b-10" onClick={handleNext}>다음</button>
                            <button className="pre" onClick={handlePre}>이전</button>
                        </div>
                    </div>
                </EstimateStepContentsPCBlock>
                <EstimateStepBlankBlock >&nbsp;</EstimateStepBlankBlock>
            <ToastLeft bottom={"0px"}/>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
            <Footer siteMovePosition={isMobileOnly?'80px':'50px'} />
        </EstimateStepBlock>
    );
};

export default EstimateStep2;
